var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    fill: "#4ECB71",
    fillOpacity: 0.07
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_10428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1251 59.5L54.2501 72.625L80.5001 46.375",
    stroke: "#4ECB71",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_10428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white",
    transform: "translate(28 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.9a4dfc80dfbc98fb4cc7e737c9381e27.svg";
export { ForwardRef as ReactComponent };